import React, {useState} from 'react';
import {Alert, Button} from "@mui/material";
import {useConfirm} from "material-ui-confirm";
import userApi from "src/api/user/userApi";
import useAuth from "src/hooks/use-auth";

const CloseAccountButton = () => {
  const confirm = useConfirm();
  const {onLogout, myUser} = useAuth();
  const [error, setError] = useState(false);

  const closeAccount = async () => {
    setError(false);
    confirm({
      title: 'Account sluiten',
      description: 'Weet je zeker dat je je account wilt sluiten? Dit is een permanente actie die niet ongedaan gemaakt kan worden.',
      confirmationText: 'Bevestigen',
      cancellationText: 'Annuleren',
    })
      .then(async () => {
        try {
          await userApi.deleteItem(myUser.id);
          onLogout();
        } catch (error) {
          setError(true);
          throw error;
        }
      })
  }

  return (
    <>
      <Button
        variant="outlined"
        color="secondary"
        onClick={closeAccount}
        sx={{mb: 2}}
      >
        Account sluiten
      </Button>
      {error && <Alert severity="error">Er is iets misgegaan, probeer het nogmaals.</Alert>}
    </>
  );
}

export default CloseAccountButton;

CloseAccountButton.propTypes = {};

CloseAccountButton.defaultProps = {};
